import styled, { css } from 'styled-components';

export const TefWrapper = styled.div`
    ${({ theme }) => css`
        display: flex;
        align-items: center;
        flex-direction: column;

        @media ${theme.breakpoints.medium.media} {
            flex-direction: row;
            gap: 1.5rem;
        }
    `};
`;

export const TefImageWrapper = styled.div`
    ${({ theme }) => css`
        position: relative;
        width: 15rem;
        height: 15.9375rem;
        margin-bottom: -2rem;
        margin-right: -1.75rem;

        @media ${theme.breakpoints.medium.media} {
            flex: 0 0 15rem;
            margin-bottom: 0;
            margin-right: -5rem;
        }

        @media ${theme.breakpoints.large.media} {
            flex: 0 0 16.25rem;
            height: 17.5rem;
            margin-right: -6rem;
        }

        @media ${theme.breakpoints.xlarge.media} {
            flex: 0 0 18.75rem;
            height: 20rem;
            margin-right: -7rem;
        }
    `}
`;

export const TextWrapper = styled.div`
    ${({ theme }) => css`
        text-align: center;
        background: ${theme.colors.campaigns.clearing.primaryContrast.hex};
        z-index: 1;
        padding-top: 1rem;

        @media ${theme.breakpoints.medium.media} {
            text-align: left;
            padding: 1rem 0 1rem 1rem;
        }
    `}
`;

export const Heading = styled.h2`
    ${({ theme }) => css`
        font-size: 1.25rem;
        line-height: 1.1;
        color: ${theme.colors.campaigns.clearing.secondary.hex};
        margin: 0 0 0.625rem;

        @media ${theme.breakpoints.large.media} {
            font-size: 1.75rem;
        }
    `}
`;

export const Citation = styled.span`
    ${({ theme }) => css`
        font-size: 1rem;
        color: ${theme.colors.campaigns.clearing.secondary.hex};

        @media ${theme.breakpoints.large.media} {
            font-size: 1.125rem;
        }
    `}
`;
